import ENV from "../env";

const getInvoiceOrderHistory = async (invoiceId, cursor) => {
  const params = new URLSearchParams();
  if (cursor) params.set("cursor", cursor);

  const response = await fetch(
    `${ENV.firebaseApiUrl}/invoice/${invoiceId}/order-history${params.toString() ? `?${params}` : ""}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    },
  );

  const responseBody = await response.json();
  if (!response.ok) {
    throw new Error(responseBody?.message || "Unable to load order history");
  }

  return {
    orders: Array.isArray(responseBody?.orders) ? responseBody.orders : [],
    nextCursor: responseBody?.nextCursor || null,
  };
};

export default getInvoiceOrderHistory;
